export type PlatformDiagnostics = {
  platform: "ios-like" | "android-like" | "desktop-or-other";
  standalone: boolean;
  touchPoints: number;
  serviceWorker: boolean;
  indexedDb: boolean;
  opfs: boolean;
  storageApi: boolean;
  persistentStorage: boolean | null;
  webShare: boolean;
  clipboardWrite: boolean;
  crossOriginIsolated: boolean;
};

export async function readPlatformDiagnostics(): Promise<PlatformDiagnostics> {
  const navigatorValue = typeof navigator === "undefined" ? undefined : navigator;
  const windowValue = typeof window === "undefined" ? undefined : window;
  const userAgent = navigatorValue?.userAgent ?? "";
  const touchPoints = navigatorValue?.maxTouchPoints ?? 0;
  const iosLike = /iPad|iPhone|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && touchPoints > 1);
  const androidLike = /Android/.test(userAgent);
  const standalone = Boolean(
    windowValue?.matchMedia?.("(display-mode: standalone)").matches ||
    (navigatorValue as Navigator & { standalone?: boolean } | undefined)?.standalone === true,
  );
  const storage = navigatorValue?.storage;
  const persistentStorage = storage?.persisted ? await storage.persisted().catch(() => null) : null;

  return {
    platform: iosLike ? "ios-like" : androidLike ? "android-like" : "desktop-or-other",
    standalone,
    touchPoints,
    serviceWorker: Boolean(navigatorValue && "serviceWorker" in navigatorValue),
    indexedDb: typeof indexedDB !== "undefined",
    opfs: Boolean(storage?.getDirectory),
    storageApi: Boolean(storage),
    persistentStorage,
    webShare: typeof navigatorValue?.share === "function",
    clipboardWrite: Boolean(navigatorValue?.clipboard?.writeText),
    crossOriginIsolated: globalThis.crossOriginIsolated === true,
  };
}
